import React from 'react'
import { AudioPropsInterface, AudioStateInterface } from './types'
import ReactDOM from 'react-dom'

class Audio extends React.Component<AudioPropsInterface, AudioStateInterface> {

  ref: HTMLAudioElement | null = null

  constructor(props) {
    super(props)
    /* @ts-ignore */
    this.containerEl = document.createElement("div");

  }

  callbackRefFn = (node) => {

    this.ref = node

  }

  state = {
    playable: false,
    playing: false
  }

  componentDidMount () {

    if (this.props.track) {
      this.createTrack()
    }

  }

  componentDidUpdate (prevProps, prevState) {

    if (!prevProps.track && this.props.track) this.createTrack()

    if (prevState.playable !== this.state.playable) this.playTrack()

  }

  playTrack = async () => {

    if (!this.ref) return

    try {

      if (Reflect.has(this.ref, 'current.play')) await this.ref.play()

      if (this.ref.paused) setTimeout(this.playTrack, 100)

    }
    catch (e) {

      console.log(e.message)

    }

  }

  createTrack () {

    if (!this.ref || !this.props.track) return

    try {

      this.props.track.attach(this.ref)

    }
    catch (e) {

      console.log(e.message)

    }

  }

  handleCanPlay = () => this.setState({ playable: true })
  handlePlay = () => this.setState({ playing: true })

  render () {

      return <audio
        muted={this.props.isMuted}
        ref={this.callbackRefFn}
        data-id={this.props.trackSid}
        data-user={this.props.trackName.split('-')[0]}
        data-bdd={`talks-track-audio`}
        autoPlay={true}
        onPlay={this.handlePlay}
        onCanPlayThrough={this.handleCanPlay}
      />

  }

}

export default Audio
